import React, { useState } from "react";
import * as yup from "yup";
import { FormikHelpers, useFormik } from "formik";

import {
  ExternalJudgmentImportCommand,
  ImportFormProps,
  //  SaveJudgmentIntegrationCommand,
  //  JudgmentIntegration,
  IntegrationCategory,
} from "../types/JudgmentIntegrationTypes";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Message } from "primereact/message";
import { Calendar } from "primereact/calendar";
import JudgmentClient from "../Api/judgment-client";
import judgmentStore from "../stores/judgment-store";

export const ExternalImportForm: React.FC<ImportFormProps> = function (props) {

  const headerTemplate = () => {
    if (
      judgmentStore.currentIntegration?.integrationCategoryID ===
      IntegrationCategory.Judgment
    ) {
      return judgmentStore.isEditing
        ? "Edit Imported Judgment Details"
        : "Import New Judgment Details";
    } else {
      return judgmentStore.isEditing
        ? "Edit Imported Satisfaction Details"
        : "Import New Satisfaction Details";
    }
  };

  const formikProps = useFormik<ExternalJudgmentImportCommand>({
    initialValues: {
      judgmentIntegrationName: judgmentStore.currentIntegration
        ? judgmentStore.currentIntegration.name
        : "",
      startDateString: null,
      startTimeString: null,
      endDateString: null,
      endTimeString: null,
      integrationCategoryID: judgmentStore.currentIntegration?.integrationCategoryID,
      canDeleteJudgmentIntegration: judgmentStore.currentIntegration?.canDeleteJudgmentIntegration
    },
    validationSchema: yup.object().shape(
      {
        judgmentIntegrationName: yup
          .string()
          .required("Integration name is required."),
        startDateString: yup
          .string()
          .nullable()
          .required("Start Date is required"),
        startTimeString: yup
          .string()
          .nullable()
          .required("Start Time is required"),
        endDateString: yup
          .string()
          .nullable()
          .required("End Date is required"),
        endTimeString: yup
          .string()
          .nullable()
          .required("End Time is required")
      }
    ),
    onSubmit: async (
      values: ExternalJudgmentImportCommand,
      { setSubmitting }: FormikHelpers<ExternalJudgmentImportCommand>
    ) => {
      let startDate = new Date(values.startDateString).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
      let endDate = new Date(values.endDateString).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
      let startTime = new Date(values.startTimeString).toLocaleTimeString('en-US')
      let endTime = new Date(values.endTimeString).toLocaleTimeString('en-US');
      values.startDate = new Date(`${startDate} ${startTime}`);
      values.endDate = new Date(`${endDate} ${endTime}`);
      let response = await JudgmentClient.importExternalJudgments(values);
      if (response.errors && response.errors.length > 0) {
        props.showToast(
          "error",
          response.message ?? "",
          response.errors[0],
          undefined,
          true
        );
      } else {
        judgmentStore.currentIntegration = response.judgmentIntegration;
        props.showToast("success", response.message ?? "", undefined, 5000);
        judgmentStore.showImportResultsTable = true;
        judgmentStore.setEditing(response.judgmentIntegration);
      }
      setSubmitting(false);
    },
    validateOnBlur: false,
    validateOnChange: false,
    enableReinitialize: true,
  });

  const nameHeaderFile = judgmentStore.currentIntegration?.integrationCategoryID === IntegrationCategory.Judgment ? "Judgment Integration Name:" : "Satisfaction Integration Name";
  return (
    <>
      <Panel header={headerTemplate()}>
        <form onSubmit={formikProps.handleSubmit}>

          <div className="p-fluid">
            <div className="p-field p-grid">
              <label htmlFor="judgmentIntegrationName" className="p-col-3 p-md-3 " >
                {nameHeaderFile}
              </label>
              <div className="p-col-9 p-md-9">
                <InputText
                  name="judgmentIntegrationName"
                  className={
                    formikProps.errors.judgmentIntegrationName &&
                      formikProps.touched.judgmentIntegrationName
                      ? "p-invalid"
                      : ""
                  }
                  value={formikProps.values.judgmentIntegrationName}
                  onChange={formikProps.handleChange}
                />
                {formikProps.errors.judgmentIntegrationName &&
                  formikProps.touched.judgmentIntegrationName && (
                    <Message
                      severity="error"
                      text={formikProps.errors.judgmentIntegrationName}
                    ></Message>
                  )}
              </div>
            </div>

            <div className="p-field p-grid">
              <div className="p-col-3 p-md-3">
                <label htmlFor="startDate">Start Date:</label>
              </div>
              <div className="p-col-3 p-md-3">
                <Calendar
                  id="startDate"
                  name="startDate"
                  placeholder="Start Date"
                  dateFormat={"mm/dd/yy"}
                  value={formikProps.values.startDateString ? new Date(formikProps.values.startDateString) : null}
                  onChange={async (e) => {
                    if (e) {
                      formikProps.setFieldValue("startDateString", e.value);
                    }
                  }}
                  className={
                    formikProps.errors.startDateString && formikProps.touched.startDateString
                      ? "p-invalid"
                      : ""
                  }
                  showIcon
                  showButtonBar
                  monthNavigator
                  yearNavigator
                  yearRange="1950:2100"
                />
                {formikProps.errors.startDateString && formikProps.touched.startDateString && (
                  <Message
                    severity="error"
                    text={formikProps.errors.startDateString}
                  ></Message>
                )}
              </div>
              <div className="p-col-3 p-md-3">
                <Calendar
                  id="startTime"
                  name="startTime"
                  placeholder="Start Time"
                  value={formikProps.values.startTimeString ? new Date(formikProps.values.startTimeString): null}
                  onChange={async (e) => {
                    if (e) {
                      formikProps.setFieldValue("startTimeString", e.value);
                    }
                  }}
                  className={
                    formikProps.errors.startTimeString && formikProps.touched.startTimeString
                      ? "p-invalid"
                      : ""
                  }
                  showIcon
                  showButtonBar
                  timeOnly
                  hourFormat="12"
                  //todayButtonClassName='time'
                />
                {formikProps.errors.startTimeString && formikProps.touched.startTimeString && (
                  <Message
                    severity="error"
                    text={formikProps.errors.startTimeString}
                  ></Message>
                )}
              </div>
            </div>
            <div className="p-field p-grid">
              <div className="p-col-3 p-md-3">
                <label htmlFor="endDate">End Date:</label>
              </div>
              <div className="p-col-3 p-md-3">
                <Calendar
                  id="endDate"
                  name="endDate"
                  placeholder="End Date"
                  dateFormat={"mm/dd/yy"}
                  value={formikProps.values.endDateString ? new Date(formikProps.values.endDateString) : null}
                  onChange={async (e) => {
                    if (e) {
                      formikProps.setFieldValue("endDateString", e.value);
                    }
                  }}
                  className={
                    formikProps.errors.endDateString && formikProps.touched.endDateString
                      ? "p-invalid"
                      : ""
                  }
                  showIcon
                  showButtonBar
                  monthNavigator
                  yearNavigator
                  yearRange="1950:2100"
                />
                {formikProps.errors.endDateString && formikProps.touched.endDateString && (
                  <Message
                    severity="error"
                    text={formikProps.errors.endDateString}
                  ></Message>
                )}
              </div>
              <div className="p-col-3 p-md-3">
                <Calendar
                  id="endTime"
                  name="endTime"
                  placeholder="End Time"
                  value={formikProps.values.endTimeString ? new Date(formikProps.values.endTimeString) : null}
                  onChange={async (e) => {
                    if (e) {
                      formikProps.setFieldValue("endTimeString", e.value);
                    }
                  }}
                  className={
                    formikProps.errors.endTimeString && formikProps.touched.endTimeString
                      ? "p-invalid"
                      : ""
                  }
                  showIcon
                  showButtonBar
                  timeOnly
                  hourFormat="12"
                  //todayButtonClassName='time'
                />
                {formikProps.errors.endTimeString && formikProps.touched.endTimeString && (
                  <Message
                    severity="error"
                    text={formikProps.errors.endTimeString}
                  ></Message>
                )}
              </div>
            </div>

            <div className="p-field p-col-2">
              <Button
                name="submit"
                type="submit"
                label={judgmentStore.isEditing ? "Save" : "Import"}
                disabled={formikProps.isSubmitting}
              />
            </div>
          </div>
        </form>
      </Panel>
    </>
  );
};
